import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "CasinoGameOfTheWeekWidget" */ './CasinoGameOfTheWeekWidget'),
  modules: ['./CasinoGameOfTheWeekWidget'],
  loading: () => <div />
});

export default LoadableWidget;
